import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const Ticket = Loader(lazy(() => import('content/ticket')));
const SingleTicket = Loader(lazy(() => import('content/ticket/single')));

const ticketRoutes = [
  {
    path: '',
    element: <Ticket />,
  },
  {
    path: ':flowCode/:taskCode',
    element: <SingleTicket />,
  },
];

export default ticketRoutes;
